export const ListQueryKey = 'questions';
export const DetailQueryKey = 'question';

export const Urls = {
  selectUrl: '/Question/list',
  updateUrl: '',
  deleteUrl: '',
  createUrl: '',
  detailUrl: '',
};
